<template>
  <component :is="decoratorComponentName"
             v-if="decoratorComponentName">
    <div id="iota-oauth2-wechat-scan"></div>
    <div class="footer">
      <wechat-outlined :style="{ color: '#a4dd53' }" />
      <span>{{ $t('oauth2_implements.WechatScan.scanMsg') }}</span>
    </div>
  </component>
  <div v-else
       class="scan">
    <div id="iota-oauth2-wechat-scan"></div>
    <div class="footer">
      <wechat-outlined :style="{ color: '#a4dd53' }" />
      <span>{{ $t('oauth2_implements.WechatScan.scanMsg') }}</span>
    </div>
    <a-button shape="circle"
              @click="gotoSignin">
      <template #icon>
        <CloseOutlined />
      </template>
    </a-button>
  </div>
</template>

<script lang="ts" setup>
import type { Plugin, SysConfigService } from '@/plugins'
import { PLUGIN_SYS_CONFIG } from '@/plugins/builtin/BuiltinPluginSymbol'
import { container } from 'tsyringe'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useOauth2 } from '../Oauth2Plugin'

// 获取系统配置
const plugin = container.resolve<Plugin<unknown, SysConfigService>>(PLUGIN_SYS_CONFIG)

const oauth2State = useOauth2()
const { providers, apiPort, decoratorComponentName } = oauth2State.$state
const { wechat } = providers

const uuid = () => {
  const temp_url = URL.createObjectURL(new Blob())
  const uuid = temp_url.toString() // blob:https://xxx.com/b250d159-e1b6-4a87-9002-885d90033be3
  URL.revokeObjectURL(temp_url)
  return uuid.substr(uuid.lastIndexOf("/") + 1)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const wxLogin = (opts: any) => {
  const c = document.createElement("iframe")
  let d = "https://open.weixin.qq.com/connect/qrconnect?appid="
    + opts.appId
    + "&scope=" + opts.scope
    + "&redirect_uri=" + opts.redirect_uri
    + "&state=" + opts.state
    + "&login_type=jssdk"
  d += opts.style ? "&style=" + opts.style : ""
  d += opts.href ? "&href=" + opts.href : ""
  c.src = d
  c.frameBorder = "0"
  // c.allowTransparency = "true"
  c.scrolling = "no"
  c.width = "200px"
  c.height = "200px"
  const e = document.getElementById(opts.id)
  while (e?.firstChild) {
    e.removeChild(e.firstChild)
  }
  e?.appendChild(c)
}

onMounted(() => {
  const state = uuid()
  const sysApiDomain = plugin.service.value('apiDomain').value?.value
  const sysApiPort = plugin.service.value('apiPort').value?.value || apiPort || 9090
  const sysAppId = plugin.service.value('wechatAppId').value?.value
  let domain = sysApiDomain ? `${sysApiDomain}:${sysApiPort}` : undefined
  if (!domain) {
    if (window) {
      const location = window.location
      domain = `${location.protocol}//${location.hostname}:${sysApiPort}`
    }
  }
  wxLogin({
    id: "iota-oauth2-wechat-scan",
    appId: sysAppId || wechat?.appId,
    scope: "snsapi_login",
    redirect_uri: wechat?.scanRedirect || `${domain}/v1/api/oauth2/third_parties/wechat/signin`,
    state,
    style: "white",
    href: 'data:text/css;base64,LmxvZ2luUGFuZWwubm9ybWFsUGFuZWwgLnRpdGxlIHsKICBkaXNwbGF5OiBub25lOwp9CgoucXJjb2RlLmxpZ2h0Qm9yZGVyIHsKICB3aWR0aDogMTYwcHg7CiAgaGVpZ2h0OiAxNjBweDsKfQ=='
  })
})

const router = useRouter()
const gotoSignin = () => {
  router.push('/signin')
}
</script>

<style scoped lang="less">
.scan {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;


}

.footer {
  display: flex;
  width: 100%;
  margin: 10px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: 'SourceHanSansCN-Regular';

  span {
    margin: 5px;
  }
}
</style>
